module.exports = __webpack_public_path__ + "img/NewsCenterDetails7_pic10.57ccd4d7.png";